<h3 mat-dialog-title>Filtrar Notificações</h3>
<div mat-dialog-content>
    <div fxLayout="row wrap">   
        
        <div fxFlex.gt-sm="100%">
            
            <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Categoria</mat-label>
                <mat-select 
                    placeholder="Categoria" 
                    [(value)]="model.categoria_id"
                    [formControl]="categoria_id"                    
                >
                    <mat-option value="">TODOS</mat-option>
                    <mat-option *ngFor="let categoria of listCategoria"
                        [value]="categoria.id">{{categoria.nome}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerCategoria"></mat-spinner> 
            </mat-form-field>        
           
        </div>

        <div fxFlex.gt-sm="100%">
            
            <mat-form-field appearance="outline" style="width: 100%" *ngIf=' usuarioLogado.role_id != 5 && usuarioLogado.role_id != 11 '>
                <mat-label>Regional</mat-label>
                <mat-select 
                    placeholder="Regional" 
                    [(value)]="model.regional_id"
                    [formControl]="regional_id" 
                    (selectionChange)="selectRegional($event)"
                >
                    <mat-option value="">TODOS</mat-option>
                    <mat-option *ngFor="let regional of listRegional"
                        [value]="regional.id">{{regional.nome}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerRegional"></mat-spinner> 
            </mat-form-field>        
           
        </div>
        
        <div fxFlex.gt-sm="100%">
            
            <mat-form-field appearance="outline" style="width: 100%" *ngIf=' usuarioLogado.role_id != 5 '>
                <mat-label>Escritório</mat-label>
                <mat-select 
                    placeholder="Escritório" 
                    [(value)]="model.escritorio_id"
                    [formControl]="escritorio_id" 
                    (selectionChange)="selectEscritorio($event)">
                    <mat-option value="">TODOS</mat-option>
                    <mat-option *ngFor="let escritorio of listEscritorios"
                        [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner> 
            </mat-form-field>        
           
        </div>

        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" style="width: 100%" *ngIf='usuarioLogado.role_id != 5'>
                <mat-label>Assessor</mat-label>
                <mat-select 
                    placeholder="Assessor"
                    [(value)]="model.assessor_id" 
                    [formControl]="assessor_id"
                    name="assessor_id" 
                >
                    <mat-option value="">Selecione...</mat-option>
                    <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>        
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100%" fxLayoutAlign="space-between center">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data de Inicio</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="picker_1" 
                    [formControl]="data_inicio" 
                    name="data_inicio" 
                    placeholder="Data de Inicio">
                <mat-datepicker-toggle matSuffix [for]="picker_1"></mat-datepicker-toggle>
                <mat-datepicker #picker_1></mat-datepicker>
            </mat-form-field>   
            
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data de Fim</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="picker_2" 
                    [formControl]="data_fim" 
                    name="data_operacao" 
                    placeholder="Data de Fim">
                <mat-datepicker-toggle matSuffix [for]="picker_2"></mat-datepicker-toggle>
                <mat-datepicker #picker_2></mat-datepicker>
            </mat-form-field>      
        </div>      
        
    </div>
</div>

<div mat-dialog-actions>

    <button
        mat-button 
        color="warn"
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
        
    <button 
        mat-button 
        (click)="salvar()" 
        tabindex="-1"
    >   Filtrar
    </button>

</div>